import { FC } from 'react';
import { DataEditorProps, GridDateProps, ValueViewerProps } from 'common/types/scalarSpreadsheet';
import { GridDate, GridDateEditor, GridDateValueViewer } from 'components/FeaturedSpreadsheet/components';
import {
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS,
  FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS,
} from 'pages/FundInvestments/common/constants';
import { shortDate } from 'utilities';
import { HandleDateCellsParams } from './handleDateCells.types';

const {
  metric_selection_as_of_date: METRIC_SELECTION_AS_OF_DATE,
  metric_selection_as_of_market_date: METRIC_SELECTION_AS_OF_MARKET_DATE,
} = FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_COLUMNS;

const { as_of_date: AS_OF_DATE } = FUND_INVESTMENTS_MARKET_ADJUSTMENT_SPREADSHEET_CALCULATIONS_COLUMNS;

const handleDateCells = (params: HandleDateCellsParams): void => {
  const { asOfDate, cell, colNumber, marketDate } = params;

  Object.assign(cell, {
    hidden: true,
    value: '',
  });

  switch (colNumber) {
    case METRIC_SELECTION_AS_OF_DATE.column:
      Object.assign(cell, {
        className: `${cell.className} subtitle-bold`,
        customKey: AS_OF_DATE.key,
        dataEditor: (props: DataEditorProps) => <GridDateEditor {...props} />,
        dbType: 'dbDate',
        gridDateComponent: GridDate as FC<GridDateProps>,
        gridType: 'gridDate',
        hidden: false,
        isRequired: true,
        readOnly: false,
        value: shortDate(asOfDate), // Ensure the date is formatted correctly (e.g., 'yyyy-MM-dd')
        valueViewer: (props: ValueViewerProps) => (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore: GridDateValueViewer is not typed
          <GridDateValueViewer {...props} slashFormatted />
        ),
      });
      break;

    case METRIC_SELECTION_AS_OF_MARKET_DATE.column:
      Object.assign(cell, {
        className: `${cell.className} subtitle-bold`,
        hidden: false,
        value: shortDate(marketDate),
      });
      break;

    default:
      break;
  }
};

export default handleDateCells;
